import { useMemo } from "react";
import { getConfig } from "@config/whiteLabelConfig";

export function useWhiteLabel() {
  const hostname = window.location.hostname;
  const domain = useMemo(() => {
    const hostParts = window.location.hostname.split(".");

    if (hostParts.length < 3) {
      return null;
    }

    if (!["klient", "localklient"].includes(hostParts[0])) {
      return null;
    }

    return hostname.split(".").slice(-2).join(".");
  }, [hostname]);

  const config = useMemo(() => {
    if (!domain) {
      return null;
    }
    return getConfig(domain);
  }, [domain]);

  return {
    hasConfig: !!config,
    config,
    faviconUrl: config?.faviconUrl,
  };
}
